const withTrailingSlash = (url: string): string =>
  url.endsWith("/") ? url : `${url}/`;

export const getCleApiPrefixOrUndefined = (): string | undefined => {
  const url = import.meta.env.VITE_CLE_API_ENDPOINT;
  if (!url) return undefined;
  return withTrailingSlash(url);
};

export const getCleApiPrefix = (): string => {
  const prefix = getCleApiPrefixOrUndefined();
  if (!prefix) {
    throw new Error("VITE_CLE_API_ENDPOINT is not configured");
  }
  return prefix;
};

export const isCleApiUrl = (url: string | undefined): boolean => {
  const prefix = getCleApiPrefixOrUndefined();
  if (!prefix || !url) return false;
  return url.startsWith(prefix);
};
